import { createContext, useContext, useState } from 'react'
import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import { getGames, getMovies } from '../api'

const Store = createContext()

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

export const useStore = () => useContext(Store)

export const ContextProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [listMovies, setListMovies] = useState([])
  const [listGames, setListGames] = useState([])
  const [selectedTab, setSelectedTab] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [signUpMode, setSignUpMode] = useState(false)
  const [selectedDrawer, setSelectedDrawer] = useState(null)
  const [message, setMessage] = useState({
    open: false,
    severty: 'success',
    msg: '',
    link: '/'
  })

  const fetchData = async () => {
    try {
      const { data: dataMovies } = await getMovies()
      const { data: dataGames } = await getGames()
      setListMovies(dataMovies)
      setListGames(dataGames)
    } catch (error) {
      console.log(error)
      setMessage(state => ({
        ...state,
        msg: error.message,
        open: true,
        severty: 'error'
      }))
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setMessage(state => ({ ...state, open: false }))
  }

  return (
    <Store.Provider value={{
      isLogin, setIsLogin,
      isLoading, setIsLoading,
      listMovies, setListMovies,
      listGames, setListGames,
      selectedTab, setSelectedTab,
      openModal, setOpenModal,
      signUpMode, setSignUpMode,
      message, setMessage,
      selectedDrawer, setSelectedDrawer,
      fetchData
    }}>
      {children}
      <Snackbar open={message.open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={message.severty}>
          {message.msg}
        </Alert>
      </Snackbar>
    </Store.Provider>
  )
}